var map = {
	"./2023/autumn/poster/day_report_win3.png": "8e3b",
	"./2023/summer/poster/day_report_win3.png": "b992",
	"./2024/autumn/poster/day_report_win3.png": "f9a1",
	"./2024/summer/poster/day_report_win3.png": "aeee",
	"./2024/winter/poster/day_report_win3.png": "085b",
	"./2025/spring/poster/day_report_win3.png": "e62f",
	"./2025/summer/poster/day_report_win3.png": "f926",
	"./2025/winter/poster/day_report_win3.png": "4253"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a4d";